<div class="container-fluid px-0">
  <app-spinner [detectRouteTransitions]="true"></app-spinner>
  @if (!isLoginPage && !isUnauthorizedPage && !isRouteLoading) {
    <app-header
      [isLoginPage]="isLoginPage"
      [isUnauthorizedPage]="isUnauthorizedPage"
      [isRouteLoading]="isRouteLoading"
      [roleName]="roleName"
      [shouldShowClientSelection]="shouldShowClientSelection">
    </app-header>
  }
  <p-toast></p-toast>
  @if (showBreadcrumb) {
    <app-breadcrumb></app-breadcrumb>
  }
  @if (!isLoginPage && !isUnauthorizedPage && !isRouteLoading) {
    <app-left-navigation
      (switchClientRequest)="openClientSelectionDialog()"></app-left-navigation>
  }
  <router-outlet></router-outlet>
  @if (!isLoginPage && !isUnauthorizedPage && !isRouteLoading) {
    <app-footer></app-footer>
  }
  <app-confirm-dialog
    #confirmDialog
    header="Session Timeout"
    message="You have been idle for a while. Do you want to continue your session?"
    acceptLabel="Yes"
    rejectLabel="No"
    (onConfirm)="continueSession()"
    (onReject)="logout()">
  </app-confirm-dialog>
</div>
